import { Controller } from "@hotwired/stimulus";

/**
 * Provides the ability to hide and show a loading status indicator.
 *
 * Example:
 * <div
 *  data-controller="loading"
 *  data-loading-active-class"opacity-1 animate-spin"
 *  data-loading-inactive-class"opacity-0 animate-none"
 * >
 *   <form
 *     data-action="turbo:before-fetch-request->loading#show turbo:frame-load->loading#hide"
 *   >
 *    <div data-loading-target="container">
 *      Loading Data…
 *    </div>
 *  </form>
 * </div>
 */

export default class extends Controller {
  static classes = ["active", "inactive"];
  static targets = ["container"];

  containerTargetConnected(_target) {
    this.hide();
  }

  hide() {
    this.containerTarget.classList.remove(...this.activeClasses);
    this.containerTarget.classList.add(...this.inactiveClasses);
  }

  show() {
    this.containerTarget.classList.add(...this.activeClasses);
    this.containerTarget.classList.remove(...this.inactiveClasses);
  }
}
